// extracted by mini-css-extract-plugin
module.exports = {"avatar":"RoundAvatar_avatar__yRgYK","avatarToken":"RoundAvatar_avatarToken__3ucfm"};